import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDNkPkJD6gqpqC8K_nyJhJ7y28c9rUz88M",
  authDomain: "kizunasoft-ebdb4.firebaseapp.com",
  projectId: "kizunasoft-ebdb4",
  storageBucket: "kizunasoft-ebdb4.firebasestorage.app",
  messagingSenderId: "155631731648",
  appId: "1:155631731648:web:ddd5512c8802e75b6f3e25"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);